import { useMemo } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { css } from '@emotion/react';
import { noop } from 'lodash-es';
import { FundWaterfallType } from '../../../schemas/ClientConfig.schema';
import { schemaToFormFields } from '../../../util/schema-utils';
import { FundDataModel, fundProfilesFormSchema } from '../../../schemas/Fund.schema';
import { getFundWaterfallType } from '../../../services/state/AppConfigStateJ';
import { createFormFromFieldsArray } from '../../../view-models/form.view-model';
import { UnstyledFieldset } from '../../CompanyProfiles/Scenarios/components/commonStyledComponents';
import { FormFactoryNoLayout } from '../../../components/Form/FormFactory';

export const SettingsFieldset = css`
  display: grid;
  margin-top: 1rem;
`;

const FORM_BASED_FIELDS = [
  'lpGpSplit',
  'lpGpSplitThreshold',
  'gpCatchUpPercentage',
  'superReturnSplit',
] as const;
const FORMULA_BASED_FIELDS = ['preferredReturnHurdle'] as const;

export function WaterfallSettingsFields({ fund }: { fund: FundDataModel }) {
  const isFormulaBased = getFundWaterfallType() === FundWaterfallType.FormulaBased;

  const form = useMemo(() => {
    const pickedFields = isFormulaBased ? FORMULA_BASED_FIELDS : FORM_BASED_FIELDS;
    const fields = schemaToFormFields(fundProfilesFormSchema().pick([...pickedFields]));
    return createFormFromFieldsArray(fields, { variant: 'form-inline' });
  }, [isFormulaBased]);
  const methods = useForm<FundDataModel>({
    defaultValues: fund!,
  });
  return (
    <FormProvider {...methods}>
      <UnstyledFieldset disabled css={SettingsFieldset}>
        <FormFactoryNoLayout form={form} onChange={noop} />
      </UnstyledFieldset>
    </FormProvider>
  );
}
